import React from 'react';
import PropTypes from 'prop-types';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import ContentWithContext from 'Views/Page/Content/Modal/Layouts/WizardStepLayout/Content';
import { useKYC } from 'Hooks/Aggregators/useKYC';

const StartKnowYourCustomerVerificationTemplate = ({ resource }) => {
  const { submitPageResource, setPageContentCollection } = usePageContentContext();
  const onKYCFinished = async ({ externalID }) => {
    resource.attr('externalId', externalID);
    const { response, error } = await submitPageResource();
    if (!error && response) {
      setPageContentCollection(response);
    }
  };
  const { startKYC, initializationError, isInitialized } = useKYC({ resource, onKYCFinished });

  if (!isInitialized || initializationError) {
    return null;
  }

  return (
    <WizardStepWrapperTemplate
      metaOverrideSet={BaseWizardStepOverride}
      resource={resource}
      layout={ContentWithContext}
      onNext={startKYC}
      primaryActionLabel="Continue"
    />
  );
};

StartKnowYourCustomerVerificationTemplate.defaultProps = {
};

StartKnowYourCustomerVerificationTemplate.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default StartKnowYourCustomerVerificationTemplate;
